import React from 'react';
import { Link } from 'react-router-dom';
import { Users, BookOpen, Shield, Target, Lightbulb } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';

const DivisionsPage: React.FC = () => {
  const divisions = [
    {
      id: 'ethics',
      name: 'AI 윤리·신뢰성·책임성 분과',
      icon: Shield,
      description: 'AI 기술의 윤리적·책임적 활용을 위한 기준과 가이드라인을 수립하고, 인간 중심의 신뢰 기반 AI 생태계 구축',
      color: 'bg-green-100 text-green-600',
      director: '김형종 (정보보호학부)',
      participants: ['이병걸(데이터사이언스학과)', '박남춘(산업디자인학과)'],
      mission: 'AI 기술의 윤리적·책임적 활용을 위한 기준과 가이드라인을 수립하고, 인간 중심의 신뢰 기반 AI 생태계 구축',
      activities: [
        'AI 윤리기준 프레임워크 및 행동 강령 개발',
        'AI 알고리즘의 편향 검출, 공정성 분석, 설명가능성(XAI) 검증',
        '초중고·대학생 대상 AI 리터러시 교육 커리큘럼 개발',
        'AI 저작권 및 개인정보 보호 윤리 가이드라인 수립',
        '사회적 약자(장애인, 고령자, 아동 등) 권익 보호 기술 개발',
        '국내 시뮬레이션 학회와 공동 학술대회 개최'
      ]
    },
    {
      id: 'education',
      name: 'AI 융합교육 개발 분과',
      icon: BookOpen,
      description: '전공과 교양 영역을 아우르는 AI 기반 융합형 혁신 교과목 개발로 AX(AI Transformation) 시대 인재 양성',
      color: 'bg-orange-100 text-orange-600',
      director: '이종태 (경영학과)',
      participants: ['이창석(화학과)', '김수연(국어국문학과)', '김평호(심리인지과학학부)', '김민서(교양대학)'],
      mission: '전공과 교양 영역을 아우르는 AI 기반 융합형 혁신 교과목 개발로 AX(AI Transformation) 시대 인재 양성',
      activities: [
        '국내외 경쟁 대학의 AX융합형 교과목 개발 트렌드 분석·공유',
        '교내외 전문가·전문인력과의 교류 회의 및 학술행사 참석·발표',
        '교내-교외 연계형 융합 교육 커리큘럼 협의 및 자유 발제',
        '주요 전공 분야(자연과학, 인문학, 사회학, 기술경영) 및 교양 영역 신규 교과목 개발 (3~5개)',
        'AX기반 교과목 확대를 위한 인프라스트럭처 활용 방안 제안',
        '전공 이수 학생의 현업 진출 가이드라인 개발'
      ]
    },
    {
      id: 'industry',
      name: '지산학 연계 분과',
      icon: Users,
      description: '지역-산업-학계 협력을 통해 현장 중심의 인간-AI 협력 연구 모델 구축 및 실무형 인재 양성',
      color: 'bg-purple-100 text-purple-600',
      director: '박후린 (지능정보보호학부)',
      participants: ['오준형(지능정보보호학부)', '최은정(지능정보보호학부)', '김예리(데이터사이언스학과)'],
      mission: '지역-산업-학계 협력을 통해 현장 중심의 인간-AI 협력 연구 모델 구축 및 실무형 인재 양성',
      activities: [
        '산업·지역 현안 기반 AI 응용 연구 주제 발굴 (데이터 분석, 예측 모델링, 생성형 AI)',
        '산업체 직접 강의 요청 및 현장 요구 중심 교육 콘텐츠 개발',
        '산학 공동 워크숍, 실습형 세미나, AI 기반 캡스톤 프로젝트 운영',
        '지역 산업 특성 반영 AI 기술의 산업 현장 적용 연구개발',
        '산업체 공동 특허 출원 및 기술 사업화 가능성 검토',
        '지산학 학술교류회 개최 및 학술 용역 사업 수행'
      ]
    },
    {
      id: 'teaching',
      name: 'AI 교수학습 분과',
      icon: Lightbulb,
      description: 'AI를 협력적 행위자로 재정립하여 인간-AI 공동지성 기반의 교수학습 패러다임 구축 및 지원 체계 개발',
      color: 'bg-yellow-100 text-yellow-600',
      director: '서윤경 (교수학습센터)',
      participants: ['장윤재(언론영상학부)', '윤이수(바이오헬스융합학과)', '이수지(인지심리과학학부)'],
      mission: 'AI를 협력적 행위자로 재정립하여 인간-AI 공동지성 기반의 교수학습 패러다임 구축 및 지원 체계 개발',
      activities: [
        '인간-AI 협력의 철학적·인지적 기반 검토 및 개념 정교화',
        '협력의 핵심 구인(인지적, 의사결정, 창의적, 신뢰 협력) 정의 및 영향 관계 분석',
        '미디어, 뇌과학, 바이오헬스 분야별 인간-AI 협력 양상 비교 연구',
        '협력 수준(초기-상호보완-공진화) 지표 체계 개발',
        '협력 수준별 교수학습 설계 가이드라인 도출',
        '교수자·학습자 대상 AI 협력 역량 교육 프로그램 및 지원 체계 설계'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="h-16" />
      <Breadcrumb />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero Section */}
        <div className="text-center mb-10">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            4개 연구 분과
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
            인간-AI 협력이라는 공통 질문을 각자의 전문성으로 탐구합니다.
          </p>
        </div>

        {/* 철학 연결 배너 */}
        <div className="bg-navy-950 text-white rounded-xl p-6 mb-14 flex flex-col md:flex-row md:items-center gap-4">
          <div className="flex-1">
            <p className="text-sm text-gray-400 mb-1">CHAIR의 출발점</p>
            <p className="text-base text-gray-200 leading-relaxed">
              AI는 우리의 데이터를 수집하고, 프로파일을 만들고, 행동을 예측합니다.
              대부분의 사람들은 이 사실을 잘 모릅니다. 4개 분과는 각자의 방식으로
              이 <strong className="text-white">인식의 격차</strong>를 좁히고,
              인간이 AI와 <strong className="text-white">대등하게 협력</strong>할 수 있는 기반을 만듭니다.
            </p>
          </div>
          <Link
            to="/philosophy"
            className="flex-shrink-0 inline-flex items-center px-4 py-2 bg-teal-500 text-white text-sm font-medium rounded-lg hover:bg-teal-600 transition-colors"
          >
            철학 읽기 →
          </Link>
        </div>

        {/* Divisions Grid */}
        <div className="space-y-12">
          {divisions.map((division, index) => {
            const IconComponent = division.icon;
            return (
              <div key={division.id} className="bg-white rounded-lg shadow-sm overflow-hidden">
                <div className="p-8">
                  <div className="flex items-start mb-6">
                    <div className={`${division.color} w-16 h-16 rounded-lg flex items-center justify-center mr-6 flex-shrink-0`}>
                      <IconComponent className="h-8 w-8" />
                    </div>
                    <div className="flex-1">
                      <h2 className="text-2xl font-bold text-gray-900 mb-2">
                        {index + 1}분과: {division.name}
                      </h2>
                      <p className="text-lg text-gray-600 mb-4">
                        {division.description}
                      </p>
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-8 mb-6">
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                        <Target className="h-5 w-5 mr-2 text-teal-600" />
                        책임교수
                      </h3>
                      <p className="text-gray-700 font-medium">{division.director}</p>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                        <Users className="h-5 w-5 mr-2 text-teal-600" />
                        참여교수
                      </h3>
                      <div className="space-y-1">
                        {division.participants.map((participant, participantIndex) => (
                          <p key={participantIndex} className="text-gray-700">{participant}</p>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="mb-6">
                    <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                      <Lightbulb className="h-5 w-5 mr-2 text-teal-600" />
                      미션
                    </h3>
                    <p className="text-gray-700">{division.mission}</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                      <BookOpen className="h-5 w-5 mr-2 text-teal-600" />
                      주요 활동
                    </h3>
                    <ul className="space-y-2">
                      {division.activities.map((activity, activityIndex) => (
                        <li key={activityIndex} className="flex items-start text-gray-600">
                          <span className="text-teal-600 mr-2">•</span>
                          <span>{activity}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Collaboration Section */}
        <section className="mt-16 bg-teal-50/60 rounded-lg p-8">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              분과 간 협력
            </h2>
            <p className="text-lg text-gray-600 mb-6 max-w-3xl mx-auto">
              각 분과는 독립적으로 연구를 수행하면서도, 인간-AI 협력이라는 공통 목표를 위해 
              긴밀하게 협력합니다. 분과 간 지식 공유와 협력 연구를 통해 
              더욱 혁신적이고 실용적인 성과를 창출합니다.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/governance" 
                className="inline-flex items-center px-6 py-3 bg-teal-500 text-white font-medium rounded-lg hover:bg-teal-600 transition-colors"
              >
                운영세칙 보기
              </Link>
              <Link 
                to="/faculty" 
                className="inline-flex items-center px-6 py-3 bg-white text-teal-600 font-medium rounded-lg border border-teal-500 hover:bg-teal-50/60 transition-colors"
              >
                교수진 소개 보기
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default DivisionsPage;
